"use client";

import {
  ComponentRendering,
  Field,
  getChildPlaceholder,
  RouteData,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { useRouter } from "next/router";
import * as Flex from "@repo/ui/flex";
import Placeholder from "../placeholder-component/placeholder";
import { isMobile } from "../utils";
import Search from "./components/search/search-field";
import TopicHeader from "./components/topic-header/topic-header";
import {
  getSearchComponent,
  getTopicTitle,
  isComponentRendering,
  isNavbarInverted,
  splitAsidePlaceholder,
} from "./utils";
import styles from "./customer-care.module.css";

export type CCComponentProps = {
  rendering: ComponentRendering;
};

const FAQLayout = ({ rendering }: CCComponentProps): JSX.Element => {
  const route = useRouter();

  const path = route.asPath;
  const isInverted = isNavbarInverted(rendering as unknown as RouteData);

  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const mobileView = isMobile();

  const dynamicComponents = getChildPlaceholder(rendering, "headless-main");
  const searchComponent = getSearchComponent(rendering);
  const splitAsideRendering = splitAsidePlaceholder(rendering);

  if (!dynamicComponents || dynamicComponents.length === 0) {
    if (!isEditing) {
      return <></>;
    }
  }

  const hasAside = dynamicComponents?.some(
    (component) =>
      "placeholders" in component &&
      component.placeholders &&
      Object.keys(component.placeholders).some((key) => key.includes("aside")),
  );

  const showHeader = hasAside && path !== "/customer-care";
  const header =
    getTopicTitle(rendering) || (rendering?.fields?.heading as Field<string>);

  const headerComponent = (
    <div className={styles.headerContainer}>
      <TopicHeader
        heading={header as Field<string>}
        tag={"p"}
        isInverted={isInverted}
      />
    </div>
  );

  return (
    <>
      {showHeader && headerComponent}
      <Flex.Container
        className={styles.faqContainer}
        justify="start"
        align={!isEditing ? "start" : undefined}
        column
      >
        <Placeholder
          name={"headless-main"}
          rendering={mobileView ? splitAsideRendering : rendering}
          classname={"contentPlaceholder"}
        />
        {mobileView &&
          searchComponent &&
          isComponentRendering(searchComponent) && (
            <Search
              fields={searchComponent.fields as { hintText: Field<string> }}
              rendering={searchComponent as ComponentRendering}
              params={{}}
            />
          )}
      </Flex.Container>
    </>
  );
};

export default FAQLayout;
